var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// Order Form shows a form for a user to add input
import { isEmpty, keys } from "ramda";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { WebSocketMessage } from "../../serverConnection";
import CountrySelect from "../common/CountrySelect";
import IndustrySelect from "../common/IndustrySelect";
import InputField from "../common/InputField";
var validate = function (user) {
    var errors = {};
    if (isEmpty(user.firstName)) {
        errors.firstName = "You must provide a value";
    }
    if (isEmpty(user.lastName)) {
        errors.lastName = "You must provide a value";
    }
    if (isEmpty(user.company)) {
        errors.company = "You must provide a value";
    }
    if (isEmpty(user.address)) {
        errors.address = "You must provide a value";
    }
    if (isEmpty(user.city)) {
        errors.city = "You must provide a value";
    }
    if (isEmpty(user.postalCode) && user.country === "DE") {
        errors.postalCode = "You must provide a value";
    }
    if (!user.email) {
        errors.email = "Required";
    }
    else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(user.email)) {
        errors.email = "Invalid email address";
    }
    return errors;
};
var EditProfile = function (props) {
    var _a;
    var _b = useState(props.currentUser), user = _b[0], setUser = _b[1];
    var updateUser = function () {
        props.send(WebSocketMessage("users", "update", user));
        props.history.push("/users");
    };
    var errors = validate(user);
    return (React.createElement("div", { className: "container content" },
        React.createElement("div", { className: "container" },
            React.createElement("h5", null, "Profile"),
            React.createElement("br", null),
            React.createElement("form", { onSubmit: function (e) {
                    e.preventDefault();
                } },
                React.createElement("div", { className: "card-panel" },
                    React.createElement(InputField, { label: "First name", type: "text", placeholder: "", meta: { touched: props.currentUser.firstName !== user.firstName, error: errors.firstName }, onChange: function (firstName) { return setUser(__assign(__assign({}, user), { firstName: firstName })); }, value: user.firstName }),
                    React.createElement(InputField, { label: "Last name", type: "text", placeholder: "", meta: { touched: props.currentUser.lastName !== user.lastName, error: errors.lastName }, onChange: function (lastName) { return setUser(__assign(__assign({}, user), { lastName: lastName })); }, value: user.lastName }),
                    React.createElement(InputField, { label: "Company", type: "text", placeholder: "", meta: { touched: props.currentUser.company !== user.company, error: errors.company }, onChange: function (company) { return setUser(__assign(__assign({}, user), { company: company })); }, value: user.company })),
                React.createElement("div", { className: "card-panel" },
                    React.createElement(InputField, { label: "Address", type: "text", placeholder: "", meta: { touched: props.currentUser.address !== user.address, error: errors.address }, onChange: function (address) { return setUser(__assign(__assign({}, user), { address: address })); }, value: user.address }),
                    React.createElement(InputField, { label: "City", type: "text", placeholder: "", meta: { touched: props.currentUser.city !== user.city, error: errors.city }, onChange: function (city) { return setUser(__assign(__assign({}, user), { city: city })); }, value: user.city }),
                    user.country === "DE" && (React.createElement(InputField, { label: "Postal code", type: "text", placeholder: "", meta: {
                            touched: props.currentUser.postalCode !== user.postalCode,
                            error: errors.postalCode,
                        }, onChange: function (postalCode) { return setUser(__assign(__assign({}, user), { postalCode: postalCode })); }, value: user.postalCode })),
                    React.createElement("div", null,
                        React.createElement(CountrySelect, { value: user.country, onChange: function (e) { return setUser(__assign(__assign({}, user), { country: e.target.value })); }, enterprises: props.enterprises }),
                        user.role === "customer" && (React.createElement(IndustrySelect, { value: (_a = user.industry) !== null && _a !== void 0 ? _a : "", onChange: function (e) { return setUser(__assign(__assign({}, user), { industry: e.target.value })); } }))),
                    React.createElement("br", null),
                    React.createElement("br", null),
                    React.createElement(Link, { to: "/users", className: "white btn-flat left red-text" }, "Cancel"),
                    React.createElement("button", { className: "teal btn-flat btn right white-text", onClick: function () { return updateUser(); }, disabled: keys(errors).length > 0 }, "Update my profile"),
                    React.createElement("br", null),
                    React.createElement("br", null))))));
};
export default withRouter(EditProfile);



//////////////////
// WEBPACK FOOTER
// ./src/components/users/EditProfile.tsx
// module id = 1233
// module chunks = 0